export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-02.643e59e8.jpg";